import styled from 'styled-components';
import { subscriptionModalSidePaddings } from '@anm/styles/helpers';
import Alert from '@anm/components/notification/Alert';

export const AlertWrapper = styled.div`
  &:not(:empty) {
    margin: 0 10px 25px;
    ${subscriptionModalSidePaddings};
  }
`;

export const UpgradeAlert = styled(Alert)`
  margin-bottom: 10px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;
